import React from "react"
import { compose } from "recompose"
import map from "lodash/map"
import size from "lodash/size"
import isEmpty from "lodash/isEmpty"

import { Flex } from "@infotech/uikit-grid"
import Accordeon, { AccordeonGroup } from "@infotech/uikit-accordeon"

import Modal from "../components/Modal"
import withPlannedChecks from "./hocs/withPlannedChecks"
import withPlannedMts from "./hocs/withPlannedMts"
import withModalState from "./hocs/withModalState"
import withPlannedDefects from "./hocs/withPlannedDefects"
import PlanAndFact from "./PlanAndFact"
import Row from "./Row"
import styles from "../styles.css"

const Plan = ({
  eventData,
  issue,
  plannedChecks = [],
  plannedMts = [],
  plannedDefectsList = [],
  isOpen,
  buttonConf,
  toggleOpen,
  onCancel,
  humanResources,
  modalProps,
}) => (
  <div className={styles.plan}>
    <Flex column>
      <Flex className={styles[`plan-title`]} justify="space-between">
        <span className={styles[`subtitle-font`]}>План</span>
        {!isEmpty(issue) && (
          <>
            <div className={styles[`link-font`]} onClick={toggleOpen}>
              Посмотреть факт
            </div>
            <Modal
              isOpen={isOpen}
              buttonConf={buttonConf}
              onCancel={onCancel}
              title="Факт выполненных работ"
              noFooter
              fullWidth
              isMenuVisible={modalProps.isMenuVisible}
              areMenuCaptionsVisible={modalProps.areMenuCaptionsVisible}
              SIDEBAR_WIDTH={modalProps.SIDEBAR_WIDTH}
              SIDEBAR_COMPACT_WIDTH={modalProps.SIDEBAR_COMPACT_WIDTH}
            >
              <PlanAndFact
                eventData={eventData}
                plannedChecks={plannedChecks}
                issue={issue}
                plannedMts={plannedMts}
                humanResources={humanResources}
              />
            </Modal>
          </>
        )}
      </Flex>
      <AccordeonGroup independent>
        <Accordeon label="Операции" badgeValue={size(plannedChecks)}>
          {map(plannedChecks, ({ description, plannedValue }) => (
            <Row title={description} value={plannedValue} />
          ))}
        </Accordeon>
        <Accordeon label="Материалы" badgeValue={size(plannedMts)}>
          {map(plannedMts, ({ name, plannedUsageValue }) => (
            <Row title={name} value={plannedUsageValue} />
          ))}
        </Accordeon>
        <Accordeon label="Дефекты" badgeValue={size(plannedDefectsList)}>
          {map(plannedDefectsList, ({ comment }) => (
            <Row title={comment} />
          ))}
        </Accordeon>
      </AccordeonGroup>
    </Flex>
  </div>
)

const enhance = compose(
  withPlannedChecks,
  withPlannedMts,
  withPlannedDefects,
  withModalState,
)

export default enhance(Plan)
